import React, {useState} from 'react';
import './GrantSkinPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {getFactionSkinImagePath} from '../../../configs/factions/skins/allFactionSkins';

const PAGE_ID = 'GrantSkinPage';

function GrantSkinPage({targetUserId, targetUserName, onBack}) {
  usePageAnalytics('GrantSkinPage');
  const [skinId, setSkinId] = useState('');
  const [granting, setGranting] = useState(false);
  const [grantedSkinId, setGrantedSkinId] = useState(null);

  const handleGrant = async () => {
    if (!skinId.trim() || granting) return;

    setGranting(true);
    setGrantedSkinId(null);
    try {
      const response = await fetch(`${API_BASE}/admin/grant-skin`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({targetUserId, skinId: skinId.trim()}),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to grant skin');
      }

      setGrantedSkinId(skinId.trim());
      setSkinId('');
      setTimeout(() => setGrantedSkinId(null), 1500);
    } catch (e) {
      console.error('Grant skin error', e);
      alert(e.message || 'Не удалось начислить скин');
    } finally {
      setGranting(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleGrant();
    }
  };

  const previewSrc = skinId.trim() ? getFactionSkinImagePath(skinId.trim()) : null;

  return (
    <>
      <h1 className="lobby-page-title grant-skin-page-title">
        Начислить скин фракции
        {targetUserName && <span className="grant-skin-page-subtitle">{targetUserName}</span>}
      </h1>

      <div className="grant-skin-form">
        <label className="grant-skin-label" htmlFor="grant-skin-id">
          ID скина фракции
        </label>
        <input
          id="grant-skin-id"
          className="grant-skin-input"
          type="text"
          value={skinId}
          onChange={(e) => setSkinId(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Например, humans_china"
          disabled={granting}
        />

        <div className="grant-skin-preview">
          {previewSrc ? (
            <img
              className="grant-skin-preview-image"
              src={previewSrc}
              alt={skinId.trim()}
            />
          ) : (
            <div className="grant-skin-preview-placeholder">Введите ID скина</div>
          )}
        </div>

        <PageButton
          className="grant-skin-submit"
          onClick={handleGrant}
          pageId={PAGE_ID}
          buttonId="grant"
          disabled={granting || !skinId.trim()}
        >
          {granting ? 'Начисление...' : 'Начислить'}
        </PageButton>

        {grantedSkinId && (
          <div className="grant-skin-success">Скин {grantedSkinId} начислен</div>
        )}
      </div>

      <div className="main-menu-buttons grant-skin-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default GrantSkinPage;
